import axios from 'axios';

const API = axios.create({ baseURL:  process.env.REACT_APP_API_URL });

export const getProperties = () => API.get('/properties');

export const getOverview = (propertyId, startDate, endDate) =>
  API.post('/overview', { propertyId, startDate, endDate });

export const getChannels = (propertyId, startDate, endDate) =>
  API.post('/channels', { propertyId, startDate, endDate });

export const getPages = (propertyId, startDate, endDate) =>
  API.post('/pages', { propertyId, startDate, endDate });

export const getDevices = (propertyId, startDate, endDate) =>
  API.post('/devices', { propertyId, startDate, endDate });

export const getGeo = (propertyId, startDate, endDate) =>
  API.post('/geo', { propertyId, startDate, endDate });

export const getRetention = (propertyId, startDate, endDate) =>
  API.post('/retention', { propertyId, startDate, endDate });

export const getEvents = (propertyId, startDate, endDate) =>
  API.post('/events', { propertyId, startDate, endDate });

export const getTech = (propertyId, startDate, endDate) =>
  API.post('/tech', { propertyId, startDate, endDate });

export const getCustomReport = (propertyId, startDate, endDate, metrics, dimensions) =>
  API.post('/custom-report', { propertyId, startDate, endDate, metrics, dimensions });

export const getAiInsights = (analyticsData, propertyName, dateRange) =>
  API.post('/ai-insights', { analyticsData, propertyName, dateRange });

// Parse GA4 runReport response into array of objects
export const parseReport = (data) => {
  if (!data || !data.rows) return [];
  const dimHeaders = (data.dimensionHeaders || []).map(h => h.name);
  const metHeaders = (data.metricHeaders || []).map(h => h.name);
  return data.rows.map(row => {
    const obj = {};
    (row.dimensionValues || []).forEach((v, i) => { obj[dimHeaders[i]] = v.value; });
    (row.metricValues || []).forEach((v, i) => { obj[metHeaders[i]] = parseFloat(v.value) || 0; });
    return obj;
  });
};

export const getRevenue = (propertyId, startDate, endDate) =>
  API.post('/revenue', { propertyId, startDate, endDate });

export const getMonetization = (propertyId, startDate, endDate) =>
  API.post('/monetization', { propertyId, startDate, endDate });

export const getRevenueAiInsights = (revenueData, analyticsData, propertyName, dateRange) =>
  API.post('/ai-insights', { revenueData, analyticsData, propertyName, dateRange, mode: 'revenue' });

export const getFunnel = (propertyId, startDate, endDate, steps) =>
  API.post('/funnel', { propertyId, startDate, endDate, steps });

export const getEventNames = (propertyId, startDate, endDate) =>
  API.post('/event-names', { propertyId, startDate, endDate });
